/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { placeControllerCreateV1 } from '../fn/place/place-controller-create-v-1';
import { PlaceControllerCreateV1$Params } from '../fn/place/place-controller-create-v-1';
import { placeControllerDeleteV1 } from '../fn/place/place-controller-delete-v-1';
import { PlaceControllerDeleteV1$Params } from '../fn/place/place-controller-delete-v-1';
import { placeControllerFindAllV1 } from '../fn/place/place-controller-find-all-v-1';
import { PlaceControllerFindAllV1$Params } from '../fn/place/place-controller-find-all-v-1';
import { placeControllerFindByIdV1 } from '../fn/place/place-controller-find-by-id-v-1';
import { PlaceControllerFindByIdV1$Params } from '../fn/place/place-controller-find-by-id-v-1';
import { placeControllerSearchCursorV1 } from '../fn/place/place-controller-search-cursor-v-1';
import { PlaceControllerSearchCursorV1$Params } from '../fn/place/place-controller-search-cursor-v-1';
import { placeControllerSearchV1 } from '../fn/place/place-controller-search-v-1';
import { PlaceControllerSearchV1$Params } from '../fn/place/place-controller-search-v-1';
import { placeControllerUpdateV1 } from '../fn/place/place-controller-update-v-1';
import { PlaceControllerUpdateV1$Params } from '../fn/place/place-controller-update-v-1';
import { PlaceDto } from '../models/place-dto';

@Injectable({ providedIn: 'root' })
export class PlaceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `placeControllerSearchV1()` */
  static readonly PlaceControllerSearchV1Path = '/api/v1/places/search';

  /**
   * 장소 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `placeControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  placeControllerSearchV1$Response(params?: PlaceControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<PlaceDto>;
}>> {
    return placeControllerSearchV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 장소 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `placeControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  placeControllerSearchV1(params?: PlaceControllerSearchV1$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<PlaceDto>;
}> {
    return this.placeControllerSearchV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<PlaceDto>;
}>): OffsetPaginationDto & {
'items'?: Array<PlaceDto>;
} => r.body)
    );
  }

  /** Path part for operation `placeControllerSearchCursorV1()` */
  static readonly PlaceControllerSearchCursorV1Path = '/api/v1/places/search/cursor';

  /**
   * Place 커서 기반 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `placeControllerSearchCursorV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  placeControllerSearchCursorV1$Response(params?: PlaceControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<PlaceDto>;
}>> {
    return placeControllerSearchCursorV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Place 커서 기반 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `placeControllerSearchCursorV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  placeControllerSearchCursorV1(params?: PlaceControllerSearchCursorV1$Params, context?: HttpContext): Observable<CursorPaginationDto & {
'items'?: Array<PlaceDto>;
}> {
    return this.placeControllerSearchCursorV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<PlaceDto>;
}>): CursorPaginationDto & {
'items'?: Array<PlaceDto>;
} => r.body)
    );
  }

  /** Path part for operation `placeControllerFindAllV1()` */
  static readonly PlaceControllerFindAllV1Path = '/api/v1/places';

  /**
   * 모든 Place 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `placeControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  placeControllerFindAllV1$Response(params?: PlaceControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PlaceDto>>> {
    return placeControllerFindAllV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 Place 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `placeControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  placeControllerFindAllV1(params?: PlaceControllerFindAllV1$Params, context?: HttpContext): Observable<Array<PlaceDto>> {
    return this.placeControllerFindAllV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PlaceDto>>): Array<PlaceDto> => r.body)
    );
  }

  /** Path part for operation `placeControllerCreateV1()` */
  static readonly PlaceControllerCreateV1Path = '/api/v1/places';

  /**
   * 장소 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `placeControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  placeControllerCreateV1$Response(params: PlaceControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return placeControllerCreateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 장소 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `placeControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  placeControllerCreateV1(params: PlaceControllerCreateV1$Params, context?: HttpContext): Observable<void> {
    return this.placeControllerCreateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `placeControllerFindByIdV1()` */
  static readonly PlaceControllerFindByIdV1Path = '/api/v1/places/{id}';

  /**
   * 장소 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `placeControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  placeControllerFindByIdV1$Response(params: PlaceControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PlaceDto>> {
    return placeControllerFindByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 장소 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `placeControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  placeControllerFindByIdV1(params: PlaceControllerFindByIdV1$Params, context?: HttpContext): Observable<PlaceDto> {
    return this.placeControllerFindByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlaceDto>): PlaceDto => r.body)
    );
  }

  /** Path part for operation `placeControllerDeleteV1()` */
  static readonly PlaceControllerDeleteV1Path = '/api/v1/places/{id}';

  /**
   * 장소 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `placeControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  placeControllerDeleteV1$Response(params: PlaceControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return placeControllerDeleteV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 장소 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `placeControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  placeControllerDeleteV1(params: PlaceControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    return this.placeControllerDeleteV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `placeControllerUpdateV1()` */
  static readonly PlaceControllerUpdateV1Path = '/api/v1/places/{id}';

  /**
   * 장소 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `placeControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  placeControllerUpdateV1$Response(params: PlaceControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return placeControllerUpdateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 장소 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `placeControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  placeControllerUpdateV1(params: PlaceControllerUpdateV1$Params, context?: HttpContext): Observable<void> {
    return this.placeControllerUpdateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
